import React from 'react';
import { version } from '../../package.json';
import { Trans } from '@lingui/react/macro';
import { cacheBustParam, urlCombine } from './url';
import { Toast } from '@ygtechnologies/bygr-frontend-component-library';

export const buildTime: Date = new Date(__BUILD_TIME__);

console.log(`Version ${version}`);
console.log(`Version ${buildTime.toLocaleString()}`);

export function initVersionMonitoring() {
    if (!import.meta.env.DEV) {
        let build: string | null = null;
        let toastVisible = false;

        setInterval(async () => {
            try {
                const response = await fetch(
                    urlCombine(window.location.origin, import.meta.env.BASE_URL, `build.txt?${cacheBustParam()}`)
                );

                if (!response.ok) {
                    throw new Error('Failed to fetch build.txt');
                }

                const newBuild = await response.text();

                if (!toastVisible && build && build !== newBuild) {
                    toastVisible = true;

                    Toast.warn(<Trans>A new version is available, click here to refresh.</Trans>, {
                        autoClose: false,
                        closeOnClick: false,
                        closeButton: false,
                        onClick: () => {
                            // @ts-ignore
                            window.location.reload(true);
                        },
                    });
                }

                build = newBuild;
            } catch (e: any) {
                console.warn('Failed to fetch build.txt', e);
            }
        }, 30000);
    }
}